module.exports = __webpack_public_path__ + "img/event-center-w.1a675d51.svg";